import { render, staticRenderFns } from "./NavUserDropdown.vue?vue&type=template&id=ae8a8b9a"
import script from "./NavUserDropdown.vue?vue&type=script&lang=js"
export * from "./NavUserDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports